<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelRota"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'secaoSelected', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_rota', null);
        return;
      }
      this.isObject ? this.$emit('selectChange', 'id_rota', e) : this.$emit('selectChange', 'id_rota', e.id);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', this.selected);
    },
    setOptions(secaoId) {
      this.isLoading = true;
      this.$atenaList
        .getRotas({
          columns: 'id, numero, nome',
          filter: `business_logic.rota.id_empresa=${this.$store.state.user.info.id_empresa} and business_logic.rota.id_secao=${secaoId} and business_logic.rota.excluido=false`,
          order: 'numero'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelRota({ nome, numero }) {
      return numero ? `${numero} - ${nome}` : `${nome}`;
    }
  },

  watch: {
    secaoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    if (this.secaoSelected) this.setOptions(this.secaoSelected);
  }
};
</script>

<style lang="scss" scoped></style>
